import { useEffect, useState } from "react";

import { useQuery } from "@apollo/client/react";
import { Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import { isTermitel } from "@/abilities/helpers";
import TTModal from "@/components/TTModal";
import { OverdueDocumentsDocument } from "@/gql/graphql";
import { useAppDispatch, useAppSelector } from "@/hooks";
import { sessionSelector } from "@/store/sessionReducer";

import DocumentsList from "./DetailDocumentsList";
import { setModalVisible, setSignatureMissing } from "./documentsReducer";
import Show from "./Show";

type Details = Nullable<TTDocumentType>;

export default function OverdueDocuments() {
  const dispatch = useAppDispatch();
  const session = useAppSelector(sessionSelector);
  const termitel = isTermitel(session.currentUser);
  const { pathname } = useLocation();
  const { t } = useTranslation(["documents"]);

  const { data, refetch } = useQuery(OverdueDocumentsDocument, { skip: !termitel });

  const [details, openDetails] = useState<Details>(null);

  useEffect(() => {
    if (!data?.overdueDocuments.length || !termitel) return;

    dispatch(setSignatureMissing(true));
    dispatch(setModalVisible(true));
  }, [pathname, dispatch, data?.overdueDocuments, termitel]);

  function hideShowModal() {
    openDetails(null);
    refetch();
  }

  if (!data?.overdueDocuments.length || !termitel) return null;

  return (
    <>
      <TTModal show={true} size="lg" backdrop="static" animation={false}>
        <Modal.Header>
          <Modal.Title>{t("documents:overdue.title")}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <DocumentsList documents={data.overdueDocuments} showDocument={(document) => openDetails(document)} />
        </Modal.Body>
      </TTModal>

      {!!details && (
        <Modal show={true} size="lg" className="xxl" backdrop="static" animation={false}>
          <Modal.Header>
            <Modal.Title>{details.subject}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Show
              session={{
                ...session,
                currentCustomer: details.customer,
                currentProject: details.project,
              }}
              id={details.id}
              cancelAction={hideShowModal}
            />
          </Modal.Body>
        </Modal>
      )}
    </>
  );
}
